import React from "react";
import { CommentsContext } from "../state/comments-context";

export default function useComments() {
  const context = React.useContext(CommentsContext);

  if (context === undefined) {
    throw new Error("useComments must be used within a CommentContextProvider");
  }

  return context;
}
